import { useEffect, useRef } from "react";

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";

// Material Kit 2 PRO React examples
import DefaultNavbar from "components/Navbars/DefaultNavbar";

// Routes
import routes from "routes";

// Images
import bgImage from "assets/images/main-3-bg.png";

// rellax
import Rellax from "rellax";

// typed-js
import Typed from "typed.js";

// Link configs
import LINKS from "config/links";

function NavbarHeader() {
    const headerRef = useRef(null);
    const typedJSRef = useRef(null);

    // Setting up rellax
    useEffect(() => {
        const parallax = new Rellax(headerRef.current, {
            speed: -6,
        });

        return () => parallax.destroy();
    }, []);

    // Setting up typedJS
    useEffect(() => {
        const typedJS = new Typed(typedJSRef.current, {
            strings: ["Validator", "Stats &amp; Charts", "Explorer"],
            typeSpeed: 80,
            backSpeed: 80,
            backDelay: 200,
            startDelay: 500,
            loop: true,
        });

        return () => typedJS.destroy();
    }, []);

    return (
        <>
            <DefaultNavbar routes={routes} transparent light />
            <MKBox
                ref={headerRef}
                minHeight="75vh"
                width="100%"
                sx={{
                    backgroundImage: ({
                        functions: { linearGradient, rgba },
                        palette: { gradients },
                    }) =>
                        `${linearGradient(
                            rgba(gradients.dark.main, 0.6),
                            rgba(gradients.dark.state, 0.6)
                        )}, url(${bgImage})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    display: "grid",
                    placeItems: "center",
                }}
            >
                <Container>
                    <Grid
                        container
                        item
                        xs={12}
                        lg={8}
                        justifyContent="center"
                        alignItems="center"
                        flexDirection="column"
                        sx={{ mx: "auto", textAlign: "center" }}
                    >
                        <MKTypography
                            variant="h1"
                            color="white"
                            sx={({ breakpoints, typography: { size } }) => ({
                                [breakpoints.down("md")]: {
                                    fontSize: size["3xl"],
                                },
                            })}
                        >
                            The Silver Fox <span ref={typedJSRef} />
                        </MKTypography>
                        <MKTypography variant="body1" color="white" opacity={0.8} mt={1} mb={3}>
                            Never funded by a large corperation! Operated by an Individual for
                            Indivduals! Home ran, Bare Metal Server meeting your decentralization
                            needs!
                        </MKTypography>
                        <MKButton
                            size="large"
                            color="primary"
                            href={LINKS.dashboard}
                            target="_blank"
                            sx={{ color: ({ palette: { dark } }) => dark.main }}
                        >
                            Foxy Dashboard
                        </MKButton>
                        <MKTypography variant="h6" color="white" mt={8} mb={1}>
                            Find us on
                        </MKTypography>
                        <MKBox display="flex" justifyContent="center" alignItems="center">
                            <MKTypography
                                component="a"
                                variant="body1"
                                color="white"
                                href={LINKS.twitter}
                                target="_blank"
                                mr={3}
                            >
                                <i className="fab fa-twitter" />
                            </MKTypography>
                            <MKTypography
                                component="a"
                                variant="body1"
                                color="white"
                                href={LINKS.discord}
                                mr={3}
                            >
                                <i className="fab fa-discord" />
                            </MKTypography>
                            <MKTypography
                                component="a"
                                variant="body1"
                                color="white"
                                href={LINKS.github}
                                target="_blank"
                                mr={0}
                            >
                                <i className="fab fa-github" />
                            </MKTypography>
                        </MKBox>
                    </Grid>
                </Container>
            </MKBox>
            ;
        </>
    );
}

export default NavbarHeader;
